export default "__VITE_ASSET__B5kx4Wo___"